<template>
    <div class="p-5">
        <div class="d-flex justify-content-between align-items-center mb-5">
            <div
                class="c-title"
                v-text="isShowArchiveMode ? 'Widgets Archive' : 'Widgets'"
            ></div>
            <div class="c-tab-list">
                <div class="row input no-gutters">
                    <SelectField
                        v-model="filterCampaign"
                        name="filter_campaign"
                        label="Campaign"
                        :options="filterCampaignItems"
                        :has-icon="true"
                        :show-tooltip="false"
                        class-wrapper="filter-campaign-dropdown"
                    >
                        <template #append-icon>
                            <a @click.prevent="() => {}">
                                <i
                                    class="fa fa-chevron-circle-down mt-2"
                                    style="font-size: 20px; color: #40b8dc"
                                />
                            </a>
                        </template>
                    </SelectField>

                    <SelectField
                        v-model="filterType"
                        name="filter_type"
                        label="Type"
                        :options="filterTypeItems"
                        :has-icon="true"
                        :show-tooltip="false"
                        class-wrapper="ml-3"
                    >
                        <template #append-icon>
                            <a @click.prevent="() => {}">
                                <i
                                    class="fa fa-chevron-circle-down mt-2"
                                    style="font-size: 20px; color: #40b8dc"
                                />
                            </a>
                        </template>
                    </SelectField>
                </div>
            </div>
            <div class="d-flex">
                <button
                    v-if="isShowArchiveMode"
                    @click="goBack"
                    class="btn c-archive-btn"
                >
                    Back
                </button>
                <button
                    v-if="!isShowArchiveMode"
                    @click="openWidgetsArchive"
                    class="btn c-archive-btn"
                >
                    Archive
                </button>
                <div v-if="!isShowArchiveMode" class="dropdown-btn">
                    <button
                        v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.WIDGET_MANAGEMENT_EDIT)"
                        class="btn c-btn-add ml-2"
                        @click="
                            () => {
                                toggleActionButton = !toggleActionButton;
                            }
                        "
                    >
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                    <div
                        v-if="toggleActionButton && DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.WIDGET_MANAGEMENT_EDIT)"
                        class="dropdown-menu"
                        :class="toggleActionButton ? 'active' : ''"
                        v-click-outside="
                            () => {
                                toggleActionButton = false;
                            }
                        "
                    >
                        <a
                            @click="openDonationModal"
                            class="dropdown-item"
                            v-text="'Donation Box'"
                        ></a>
                        <a
                            @click="openSupporterModal"
                            class="dropdown-item"
                            v-text="'Supporter Roll'"
                        ></a>
                        <a
                            @click="openGoalMeterModal"
                            class="dropdown-item"
                            v-text="'Goal Meter'"
                        ></a>
                    </div>
                </div>
            </div>
        </div>

        <div class="table-responsive" style="overflow: visible">
            <table class="table">
                <thead class="c-thead">
                    <tr>
                        <th scope="col" class="h-id">ID</th>
                        <th scope="col" class="h-name" style="cursor: pointer">
                            Name
                        </th>
                        <th scope="col" class="h-type" style="cursor: pointer">
                            Type
                        </th>
                        <th
                            scope="col"
                            class="h-campaign-title"
                            style="cursor: pointer"
                        >
                            Campaign
                        </th>
                        <th scope="col" class="h-end-date">Statistics</th>
                        <th scope="col" class="h-status"></th>
                    </tr>
                </thead>
                <tbody v-if="widgets.length">
                    <TableItem
                        v-for="item in widgets"
                        :key="item.widget_id"
                        :data="item"
                        :is-archived="isShowArchiveMode"
                        @refresh="getAllWidgets(true)"
                        @clone="cloneItem"
                        @edit="editItem"
                    />
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="6" class="text-center">No data</td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-center" v-if="totalPage > 1">
                <CustomPagination
                    :activePage="currentPage"
                    :totalPage="totalPage"
                    @paginationHandle="onClickPagging"
                ></CustomPagination>
            </div>
        </div>

        <ModalWidgetClone
            v-if="isShowCloneItemModal"
            :data="cloneItemData"
            @success="(widget) => {
                this.clonedWidget = widget;
                isShowCloneItemModal = false;
                getAllWidgets(true);
            }"
            @close="isShowCloneItemModal = false"
        />

        <ModalWidgetDonation
            v-if="isShowDonationModal"
            :data="editItemData"
            :filterCampaignItems="filterCampaignItems"
            :is-read-only="!DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.WIDGET_MANAGEMENT_EDIT)"
            @success="() => {
                isShowDonationModal = false;
                getAllWidgets();
            }"
            @close="isShowDonationModal = false"
        />

        <ModalWidgetSupporter
            v-if="isShowSupporterModal"
            :data="editItemData"
            :filterCampaignItems="filterCampaignItems"
            :is-read-only="!DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.WIDGET_MANAGEMENT_EDIT)"
            @success="() => {
                isShowSupporterModal = false;
                getAllWidgets();
            }"
            @close="isShowSupporterModal = false"
        />

        <ModalWidgetGoalMeter
            v-if="isShowGoalMeterModal"
            :data="editItemData"
            :filterCampaignItems="filterCampaignItems"
            :is-read-only="!DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.WIDGET_MANAGEMENT_EDIT)"
            @success="() => {
                isShowGoalMeterModal = false;
                getAllWidgets();
            }"
            @close="isShowGoalMeterModal = false"
        />
    </div>
</template>

<script>
import TableItem from './components/TableItem.vue';
import DibbleJs from '@/dibble';
import DibbleApi from '@/api';
import CustomPagination from '@/commons/CustomPagination/CustomPagination.vue';
import { EventBus } from '@/utils/event-bus';
import DibbleJS from '@/dibble';
import Authorizations from '@/utils/authorizations';
import SelectField from '@/commons/FormElements/SelectField.vue';
import ModalWidgetClone from '@/components/widgets/components/ModalWidgetClone.vue';
import ModalWidgetDonation from '@/components/widgets/components/ModalWidgetDonation.vue';
import ModalWidgetSupporter from '@/components/widgets/components/ModalWidgetSupporter.vue';
import ModalWidgetGoalMeter from '@/components/widgets/components/ModalWidgetGoalMeter.vue';

export default {
    name: 'ListView',
    computed: {
        Authorizations() {
            return Authorizations;
        },
        DibbleJS() {
            return DibbleJS;
        },
    },
    components: {
        ModalWidgetClone,
        SelectField,
        CustomPagination,
        TableItem,
        ModalWidgetDonation,
        ModalWidgetSupporter,
        ModalWidgetGoalMeter,
    },
    data() {
        return {
            isShowArchiveMode: false,
            isShowCloneItemModal: false,
            cloneItemData: null,
            editItemData: null,
            toggleActionButton: false,
            widgets: [],
            widgetTypes: [],
            totalPage: 0,
            currentPage: 0,
            search_keyword: this.$route.query.q || '',
            filterCampaignItems: [
                {
                    label: 'All',
                    value: '',
                },
            ],
            filterTypeItems: [
                {
                    label: 'All',
                    value: '',
                },
            ],
            filterCampaign: '',
            filterType: '',
            isShowDonationModal: false,
            isShowSupporterModal: false,
            isShowGoalMeterModal: false,
            clonedWidget: null
        };
    },
    methods: {
        goBack() {
            this.$router.push({ path: '/widgets' });
        },
        openWidgetsArchive() {
            this.$router.push({ path: '/widgets/archive' });
        },
        getAllCampaign() {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.getAllCampaign,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    if (response.campaigns.length) {
                        response.campaigns.forEach((item) => {
                            this.filterCampaignItems.push({
                                label: item.title,
                                value: item.campaign_id,
                            });
                        });
                    }
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        getAllWidgets(reset = false) {
            if (reset) {
                this.currentPage = 0;
            }
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.getAllWidgets,
            };

            if (this.search_keyword) {
                data.search_string = this.search_keyword;
            }
            if (this.filterCampaign) {
                data.filter_campaign_id = this.filterCampaign;
            }
            if (this.filterType) {
                data.filter_type = this.filterType;
            }
            data.page = this.currentPage;

            if (this.isShowArchiveMode) {
                data['show_archive'] = 1;
            }

            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.widgets = response.widgets;

                    if (this.filterTypeItems.length === 1) {
                        for (const i in response.widget_types) {
                            this.filterTypeItems.push({
                                label: response.widget_types[i],
                                value: i,
                            });
                        }
                    }

                    this.totalPage = response.num_of_pages;

                    if (this.clonedWidget) {
                        this.editItem(this.clonedWidget)
                        this.clonedWidget = null
                    }
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },

        onClickPagging(page) {
            this.currentPage = page.pageIndex - 1;
            this.getAllWidgets();
        },
        cloneItem(item) {
            this.cloneItemData = item;
            this.isShowCloneItemModal = true;
        },
        getWidgetData(widget_id) {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.widgetGet,
                widget_id: widget_id,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.editItemData = response;
                    this.openWidgetEditModal()
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        editItem(item) {
            this.getWidgetData(item.widget_id)
        },
        openWidgetEditModal() {
            switch (this.editItemData.type) {
                case 1:
                    this.isShowDonationModal = true;
                    break;
                case 2:
                    this.isShowSupporterModal = true;
                    break;
                case 3:
                    this.isShowGoalMeterModal = true;
                    break;
            }
        },
        openDonationModal() {
            this.editItemData = null;
            this.isShowDonationModal = true;
            this.toggleActionButton = false;
        },
        openSupporterModal() {
            this.editItemData = null;
            this.isShowSupporterModal = true;
            this.toggleActionButton = false;
        },
        openGoalMeterModal() {
            this.editItemData = null;
            this.isShowGoalMeterModal = true;
            this.toggleActionButton = false;
        },
    },
    watch: {
        $route(value) {
            switch (value.name) {
                case 'Widgets':
                    this.isShowArchiveMode = false;
                    break;
                case 'Widgets Archive':
                    this.isShowArchiveMode = true;
                    break;
            }

            if (this.search_keyword) {
                if (value.query.q !== this.search_keyword) {
                    this.search_keyword = value.query.q;
                    this.getAllWidgets();
                }
            } else {
                this.getAllWidgets(true);
            }
        },
        filterCampaign() {
            this.currentPage = 0;
            this.getAllWidgets();
        },
        filterType() {
            this.currentPage = 0;
            this.getAllWidgets();
        },
    },
    created() {
        if (this.$route.name === 'Widgets Archive') {
            this.isShowArchiveMode = true;
        }

        this.getAllCampaign();
        this.getAllWidgets();

        EventBus.$on('searchWidgets', (keyword) => {
            this.search_keyword = keyword;
            this.getAllWidgets();
        });
    },
};
</script>

<style lang="scss" scoped>
.filter-campaign-dropdown {
    width: 350px;
}

.c-title {
    color: #2178ab;
    font-size: 22px;
    font-weight: 700;
}

.c-tab-list {
    border-radius: 20px;
    overflow: visible;
    display: flex;
    justify-content: center;
    align-items: center;
}

.c-btn-add {
    color: #fff;
    width: 61px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #2178ab;
    border-radius: 20px;
    font-size: 24px;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}

.c-thead {
    th {
        color: #41b8dc;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;

        &.h-id {
            width: 5%;
        }

        &.h-name {
            width: 25%;
        }

        &.h-type {
            width: 5%;
        }

        &.h-campaign-title {
            width: 25%;
        }

        &.h-end-date {
            width: 15%;
        }

        &.h-type {
            width: 10%;
        }

        &.h-status {
            width: 10%;
        }
    }
}

.c-archive-btn {
    border-radius: 20px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 120px;
    color: #555e67;
    line-height: 140%;
}

.dropdown-btn {
    position: relative;

    span {
        display: block;

        &.top {
            font-size: 12px;
            line-height: 16px;
            color: #555e67;
            position: absolute;
            top: -1px;
        }
    }

    .dropdown-menu {
        position: absolute;
        top: 100%;
        left: -120px;
        z-index: 1000;
        display: none;
        min-width: 10rem;
        text-align: left;
        list-style: none;

        background-clip: padding-box;
        border: none;
        border-radius: 30px;
        width: 205px;
        background: none;

        &.active {
            display: block;
        }

        .dropdown-item {
            color: #555e67;
            font-size: 20px;
            font-weight: 700;
            background-color: #edf5f7;
            padding: 12px 35px;
            border-bottom: 1px solid #dee6ea;
            cursor: pointer;

            &:first-child {
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
            }

            &:last-child {
                border-bottom-left-radius: 30px;
                border-bottom-right-radius: 30px;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
            }

            &:hover {
                background-color: #bae3ef;
                color: #2178ab;
            }
        }
    }
}
</style>
